import React, { useEffect, useMemo } from 'react';
import { Stack, StackItem, TextList, TextListItem, Text, TextContent } from '@patternfly/react-core';
import _ from 'lodash';

import { useTranslation } from 'localization/useTranslation';
import ModelType from 'components/Model/ModelType';
import ModelsContainer from 'components/Model/ModelsContainer';
import SimpleTable, { SortDirection } from 'components/Common/SimpleTable/SimpleTable';
import Tl from 'localization/LocalizationKeys';

const columns = [
  {
    label: Tl.common.name,
    path: 'displayName',
    isSortable: true,
    searchItem: true
  }
];

const DefaultSortBy = {
  path: 'displayName',
  direction: SortDirection.DESC
};

const MigrationReviewStep = ({ assets, migrationInfo, setIsValid }) => {
  const T = useTranslation();
  const filteredAssets = useMemo(() => {
    return _.filter(assets, asset => _.some(migrationInfo.targetAssetIds, targetAssetId => targetAssetId === asset.id));
  }, [assets, migrationInfo.targetAssetIds]);

  // TODO: translate
  const assetModel = useMemo(() => {
    const d = [
      {
        type: ModelType.DISPLAY_TEXT,
        label: 'Current Asset Model',
        path: 'sourceModel',
        properties: {
          textVariant: 'p',
          render: (model) => {
            return `${model?.displayName} (${model?.id})`;
          }
        }
      },
      {
        type: ModelType.DISPLAY_TEXT,
        label: 'Target Asset Model',
        path: 'targetModel',
        properties: {
          textVariant: 'p',
          render: (model) => {
            return `${model?.displayName} (${model?.id})`;
          }
        }
      }
    ];
    if (!_.isEmpty(migrationInfo?.bindingMap)) {
      d.push({
        type: ModelType.DISPLAY_TEXT,
        label: 'Target Bindings',
        path: 'bindingMap',
        properties: {
          textVariant: 'p',
          render: (model) => {
            return (
              <TextList component="ol" isPlain>
                {
                  _.map(model, (value, key) => {
                    return (
                      <TextListItem component="li" key={key}>
                        <b>current</b>{ ` ${key} ` }<strong> migrates to</strong>{ ` ${value.displayName} (${value.id})` }
                      </TextListItem>
                    );
                  })
                }
              </TextList>
            );
          }
        }
      });
    }
    return d;
  }, [migrationInfo?.bindingMap]);

  useEffect(() => {
    // TODO: why is this needed?
    setIsValid(true);
  }, [setIsValid]);

  return (
    <Stack>
      <StackItem >
        <ModelsContainer models={assetModel} data={migrationInfo} setData={() => {}} />
      </StackItem>
      <StackItem>
        <TextContent>
          <Text component="h3">Assets to migrate</Text>
        </TextContent>
        <SimpleTable
          isLoading={_.isEmpty(assets)}
          data={filteredAssets}
          columns={columns}
          sortBy={DefaultSortBy}
          errorText={T.admin.model.list.error}
          compact
        />
      </StackItem>
    </Stack>
  );
};

export default MigrationReviewStep;
